import { render, staticRenderFns } from "./LanTravel.vue?vue&type=template&id=6fd69d26&scoped=true"
import script from "./LanTravel.vue?vue&type=script&lang=js"
export * from "./LanTravel.vue?vue&type=script&lang=js"
import style0 from "./LanTravel.vue?vue&type=style&index=0&id=6fd69d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd69d26",
  null
  
)

export default component.exports